import React, { useState } from 'react';
import UserProfileToggle from './user_profile_toggle';

export default function PrintBrokerBioToggle({ showPrintBrokerBio }: Props) {
  const [shouldShowPrintBrokerBio, setShouldShowPrintBrokerBio] = useState(showPrintBrokerBio);

  return (
    <UserProfileToggle
      checked={shouldShowPrintBrokerBio}
      label="Show print button for broker bio"
      name="user[show_print_broker_bio_on_broker_plugin]"
      onChange={() => setShouldShowPrintBrokerBio(!shouldShowPrintBrokerBio)}
    />
  );
}

type Props = {
  showPrintBrokerBio: boolean;
};
